import React, { useMemo, useRef } from 'react';

import type { SearchContextProviderProps } from './types';
import { SearchContext } from 'client-site-chrome-ui/context/SearchContext/SearchContext';
import { useSiteChromeStaticContext } from 'client-site-chrome-ui/context/SiteChromeStaticContext/useSiteChromeStaticContext';
import { useSearch } from 'client-site-chrome-ui/hooks/useSearch/useSearch';

export const SearchContextProvider = ({ children, ...props }: SearchContextProviderProps) => {
  const { cookies, env, searchedTerm } = useSiteChromeStaticContext();
  const search = useSearch({ env, searchedTerm, cookies });
  const searchSuggestionsRef = useRef<HTMLDivElement | null>(null);

  const memoizedValue = useMemo(
    () => ({
      search,
      searchSuggestionsRef,
    }),
    [search, searchSuggestionsRef],
  );

  return (
    <SearchContext.Provider value={memoizedValue} {...props}>
      {children}
    </SearchContext.Provider>
  );
};
